import { useState } from "react";
import { Button, Dialog, TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Signifier from "../../../App/Components/Signifier/Signifier";
import { basicConvertDate } from "../../../App/Helpers/DateConverters";
import RoleModal from "./RoleModal";
import { NavLink } from "react-router-dom";
import { CRMRoles } from "../../../App/Enums/CRMRoles";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "default !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "default !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },

  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    [theme.breakpoints.down("md")]: {
      width: "auto",
    },
    width: "800px",
    color: theme.palette.primary.copy,
  },
}));

export default function UserTableCell(props) {
  const classes = useStyles();
  const [roleModal, setRoleModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);

  function openModal(e) {
    e.preventDefault();
    setRoleModal(true);
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <TableRow
        hover
        className={props.index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={props.index}
        component={NavLink}
        to={{ pathname: "/users/usersdetailed", state: props.element }}
        ref={props.innerRef}
        {...props}
      >
        {props.columns.map((column, elementIndex) => (
          <TableCell
            align="left"
            key={elementIndex}
            className={classes.tableCell}
          >
            {column.label === "Name" ? (
              props.element.user?.firstName + " " + props.element.user?.lastName
            ) : column.label === "Email Address" ? (
              props.element.user?.emailAddress
            ) : column.label === "User Role(s)" ? (
              <div>
                {props.customProps.selectClient.hasCareers &&
                props.customProps.canEditCareersRoles ? (
                  <>
                    {props.element.role == null ? (
                      props.element.editCrmOnly ? (
                        <div style={{ color: "#a19b9a", margin: "0px" }}>
                          No Careers Access
                          <br></br>
                        </div>
                      ) : (
                        <>
                          No Careers Access
                          <br></br>
                        </>
                      )
                    ) : props.element.editCrmOnly ? (
                      <div style={{ color: "#a19b9a", margin: "0px" }}>
                        {props.element.role.name}
                        <br></br>
                      </div>
                    ) : (
                      <>
                        {props.element.role.name}
                        <br></br>
                      </>
                    )}
                  </>
                ) : null}
                {!props.customProps.canEditCrmRoles ? null : (
                  <>{CRMRoles[props.element.crmRole].name}</>
                )}
              </div>
            ) : column.label === "" ? (
              <Button
                variant="outlined"
                color="primary"
                onClick={(e) => openModal(e)}
              >
                {!props.customProps.canEditCrmRoles
                  ? "Edit Careers Role"
                  : props.element.editCrmOnly
                  ? "Edit CRM Role"
                  : "Edit Roles"}
              </Button>
            ) : column.label === "Date Created" ? (
              basicConvertDate(props.element.user?.dateCreated)
            ) : (
              props.element[column.propName]
            )}
          </TableCell>
        ))}
      </TableRow>
      <Dialog
        open={roleModal}
        fullWidth
        maxWidth="sm"
        onClose={() => setRoleModal(false)}
      >
        <RoleModal
          user={props.element.user}
          role={props.element.role}
          rights={props.element.rightsFlag}
          crmRole={props.element.crmRole}
          editCrmOnly={props.element.editCrmOnly}
          canEditCrmRoles={props.customProps.canEditCrmRoles}
          setModal={setRoleModal}
          setTableData={props.setTableData}
          setShowSignifier={setShowSignifier}
          setResponseMessage={setResponseMessage}
          setShowError={setShowError}
        />
      </Dialog>
    </>
  );
}
